import React, { useState, useEffect } from 'react';
import { View, Text, ScrollView, Platform, TouchableOpacity, Image } from 'react-native';
import { i18n } from './common/localization';
import { styles } from './common/styles';
const iconIosShare = require('./assets/share.png');

const isWeb = Platform.OS === 'web';

export const InstallLandingPage = ({ onContinue }) => {
  const [os, setOs] = useState('desktop'); 

  useEffect(() => {
    if (isWeb) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) setOs('ios');
      else if (/android/.test(userAgent)) setOs('android');
    }
  }, []);

  const ThreeDotsIcon = () => (
    <View style={styles.installLanding.iconThreeDotsContainer}>
      {[1, 2, 3].map(i => <View key={i} style={styles.installLanding.iconDot} />)}
    </View>
  );

  const ThreeDotsIconIOS = () => (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
      {[1, 2, 3].map(i => (
        <View key={i} style={styles.installLanding.iconDot} />
      ))}
    </View>
  );

  const AddIcon = () => (
    <View style={styles.installLanding.iconAddContainer}>
        <Text style={styles.installLanding.iconAddText}>+</Text>
    </View>
  );

  return (
    <ScrollView contentContainerStyle={styles.installLanding.container} showsVerticalScrollIndicator={false}>
      
      <View style={styles.installLanding.hero}>
        <Text style={styles.installLanding.appName}>{i18n.t("appName")}</Text> 
        <Text style={styles.installLanding.title}>{i18n.t("installTitle")}</Text>
        <Text style={styles.installLanding.subtitle}>
          {i18n.t("installSubtitle")}
        </Text>
      </View>

      {os === 'ios' && (
        <View style={styles.installLanding.card}>
          <Text style={styles.installLanding.cardTitle}>{i18n.t("iosTitle")}</Text>
          
          {/* STEP 1: Tre puntini */}
          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>1</Text></View>
              <Text style={styles.installLanding.stepText}>Clicca i 3 puntini in basso a destra</Text>
            </View>
            <View style={styles.installLanding.mockMenuRow}>
              <Text style={{color: '#999', fontSize: 16}}>CircoloDellaVela.it</Text>
              <View style={{ width: 20 }} />
              <ThreeDotsIconIOS />
            </View>
          </View>
          <View style={styles.installLanding.divider} />

          {/* STEP 2: Condividi */}
          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>2</Text></View>
              <Text style={styles.installLanding.stepText}>Clicca su Condividi</Text>
               <Image source={iconIosShare} style={{width: 24, height: 24, resizeMode: 'contain', marginRight: 22}} />
            </View>
          </View>

          <View style={styles.installLanding.divider} />

          {/* STEP 3: Altro */}
          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>3</Text></View>
              <Text style={styles.installLanding.stepText}>Premi "Altro"</Text>
              <View style={{marginRight: 25}}>
               <ThreeDotsIconIOS />
              </View>
            </View>
          </View>

          <View style={styles.installLanding.divider} />

          {/* STEP 4: Aggiungi a Home */}
          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>4</Text></View>
              <Text style={styles.installLanding.stepText}>Premi "Aggiungi alla schermata Home"</Text>
              <View style={{marginRight: 22}}>
                <AddIcon />
              </View>
            </View>
          </View>

        </View>
      )}

      {os === 'android' && (
        <View style={styles.installLanding.card}>
          <Text style={styles.installLanding.cardTitle}>{i18n.t("androidTitle")}</Text>

          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>1</Text></View>
              <Text style={styles.installLanding.stepText}>{i18n.t("androidStep1")}</Text>
            </View>
            <View style={styles.installLanding.mockMenuRow}>
               <Text style={{color: '#555'}}>CircoloDellaVela.it</Text>
               <ThreeDotsIcon />
            </View>
          </View>

          <View style={styles.installLanding.divider} />

          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>2</Text></View>
              <Text style={styles.installLanding.stepText}>{i18n.t("androidStep2")}</Text>
            </View>
            <View style={styles.installLanding.mockMenuRow}>
               <Text style={styles.installLanding.mockMenuText}>Aggiungi a schermata Home</Text>
               <Image source={{uri: 'https://img.icons8.com/material-outlined/24/000000/download--v1.png'}} style={{width: 20, height: 20, opacity: 0.6}} />
            </View>
          </View>

          <View style={styles.installLanding.divider} />

          <View style={styles.installLanding.stepBlock}>
            <View style={styles.installLanding.stepHeader}>
              <View style={styles.installLanding.numberBadge}><Text style={styles.installLanding.numberText}>3</Text></View>
              <Text style={styles.installLanding.stepText}>{i18n.t("androidStep3")}</Text>
            </View>
          </View>
        </View>
      )}

      {os === 'desktop' && (
        <View style={styles.installLanding.card}>
          <Text style={styles.installLanding.cardTitle}>{i18n.t("desktopTitle")}</Text>
          <Text style={styles.installLanding.stepText}>
            {i18n.t("desktopStep")}
          </Text>
        </View>
      )}

      {/* Continue Button
      <TouchableOpacity style={styles.installLanding.continueButton} onPress={onContinue}>
        <Text style={styles.installLanding.continueText}>{i18n.t("continueBrowser")}</Text>
      </TouchableOpacity>
      */}
    </ScrollView>
  );
};